// @react/hooks/useBillingBalance.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingBalanceStore } from '@core/stores';

/**
 * React hook for BalanceTransaction operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingBalance } from '@react/hooks';
 *
 * const BalanceTransactionList = observer(() => {
 *   const store = useBillingBalance();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingBalance() {
  return billingBalanceStore;
}
